import { Helmet } from "react-helmet";
import { SideBar } from "../side-bar/SideBar";
import React, { useState } from "react";
import Published from "./published";
import Archive from "./Archive";
import Dropdowns from "./Dropdowns";
import ArchiveRoles from "./ArchiveRoles";
import SpreadSheetJD from "./SpreadSheetJd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUpload, faDatabase, faListCheck, faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import { faFileExcel } from "@fortawesome/free-regular-svg-icons";

export function ManageJDL (){
    const [content, setContent] = useState<React.JSX.Element>(<Published />);
    
    return (
        <div className='content flex'>
             <Helmet>
                <title>Manage JDL</title>
            </Helmet>
            <SideBar />
            <div className='main-content py-4'>
                <div className='flex p-4 bg-white w-full border rounded-lg shadow-md'>
                    <ul className='ms-auto flex gap-8'>
                        <li onClick={()=> setContent(<Published />)} className='header-tab'>
                            <FontAwesomeIcon icon={faDatabase} /> &nbsp;
                            DB Roles
                        </li>
                        <li onClick={()=> setContent(<Archive />)} className='header-tab'>
                            <FontAwesomeIcon icon={faUpload} /> &nbsp;
                            Import to ERS
                        </li>
                        <li onClick={()=> setContent(<SpreadSheetJD />)} className='header-tab hover:text-green-500'>
                            <FontAwesomeIcon icon={faFileExcel} /> &nbsp;
                            SpreadSheet Roles
                        </li>
                        <li onClick={()=> setContent(<Dropdowns />)} className='header-tab'>
                            <FontAwesomeIcon icon={faListCheck} /> &nbsp;
                            Dropdowns
                        </li>
                        <li onClick={()=> setContent(<ArchiveRoles />)} className='header-tab'>
                            <FontAwesomeIcon icon={faTrashAlt} /> &nbsp;
                            Archives
                        </li>
                    </ul>
                </div>
                <div className="my-1">
                    {content}
                </div>
            </div>
        </div>
    );
}